import React, { Component } from 'react';

class IconChatHideWindow extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="29"
                fill="none"
                viewBox="0 0 28 29"
            >
                <g fill="#fff" clipPath="url(#clip0_5701_22229)">
                    <path d="M20.139 13.595L15.189 8.6a1.617 1.617 0 00-.3-.242 1.154 1.154 0 00-1.535.277 1.153 1.153 0 00.092 1.58c.6.623 1.212 1.234 1.823 1.845l1.235 1.234H9.269a1.153 1.153 0 00-1.153.623 1.153 1.153 0 00.173 1.384c.25.242.586.374.934.369h7.258l-3.035 3.01a1.152 1.152 0 000 1.718 1.155 1.155 0 00.82.358c.343-.006.67-.147.911-.392l5.008-4.982a1.155 1.155 0 00-.046-1.788zM25.965 17.804a1.154 1.154 0 00-1.281-.888 1.154 1.154 0 00-1.05 1.153v5.259c0 .53-.22.75-.762.75h-5.169a1.154 1.154 0 00-1.28 1.153 1.153 1.153 0 00.322.83 1.327 1.327 0 00.958.37h5.342a3 3 0 003.023-3.01v-3.76-1.534a1.467 1.467 0 00-.103-.323zM10.354 2.5H4.885A3.012 3.012 0 002 5.523a1.153 1.153 0 002.308 0 .634.634 0 01.704-.657h5.342a1.154 1.154 0 00.854-.358 1.21 1.21 0 00.334-.842 1.15 1.15 0 00-.733-1.086 1.154 1.154 0 00-.455-.078zM3.19 9.385a1.154 1.154 0 00.83-.346 1.154 1.154 0 00.358-.853 1.153 1.153 0 00-2.308 0 1.222 1.222 0 001.154 1.153l-.034.046zM3.052 12.072h.288a1.154 1.154 0 001.038-1.153 1.153 1.153 0 00-.346-.854 1.154 1.154 0 00-.853-.346 1.154 1.154 0 00-1.154 1.153 1.153 1.153 0 001.027 1.2z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_5701_22229">
                        <path
                            fill="#fff"
                            d="M0 0H24V24H0z"
                            transform="translate(2 2.5)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconChatHideWindow;